import React, {Component} from 'react';
import _ from 'lodash';
import connect from 'react-redux/es/connect/connect';
import {Button, PanelGroup, Modal, Panel, Badge, Col} from 'react-bootstrap';
import ReactLoading from 'react-loading';
import {NewAuthorizedPerson} from './NewAuthorisedPerson';
import ConfirmDelete from './ConfirmDelete';
import FormField from '../formField/FormField';

class AuthorisedPersonsComponent extends Component {
    constructor(props) {
        super(props);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleNewAuthorisedPerson = this.handleNewAuthorisedPerson.bind(this);
        this.state = {
            activeKey: null,
            errors: null,
            newAuthorisedErrors: {},
            newAuthorised: false,
            isLoading: false,
            newAP: {
                new: true
            },
            searchComplete: false,
            removing: false,
            removingAP: null,
        };
    }

    handleNewAuthorisedPerson() {
        const {newAP} = this.state;
        const {handleAddAuthorisedPerson} = this.props;
        const newAuthorisedErrors = {};
        const {firstName} = newAP;
        const {lastName} = newAP;
        const {identityNumber} = newAP;
        if (!firstName)
            newAuthorisedErrors.firstName = 'error';
        if (!lastName)
            newAuthorisedErrors.lastName = 'error';
        if (!identityNumber)
            newAuthorisedErrors.identityNumber = 'error';
        if (_.isEmpty(newAuthorisedErrors)) {
            handleAddAuthorisedPerson(newAP);
            this.setState({newAuthorisedErrors, newAuthorised: false, newAP: {new: true}})
        } else {
            this.setState({newAuthorisedErrors})
        }
    }

    onSave = () => {
        const {handleSave} = this.props;
        handleSave && handleSave();
        this.setState({activeKey: null});
    };

    handleSelect(activeKey) {
        this.setState({activeKey});
    }

    onIndividualSearch = () => {
        this.setState({errors: {}});
        this.loadingStart();

        const onFinish = (finish, individual) => {
            let {newAP} = this.state;
            this.loadingFinish();
            newAP = {...newAP, ...individual};
            this.setState({newAP, searchComplete: true});
            console.log(this.props.individual);
        };
        this.props.actions.fetchIndiviualInfo(this.state.newAP.identityNumber, onFinish);
    };

    loadingStart = () => {
        this.setState({isLoading: true})
    };

    loadingFinish = () => {
        this.setState({isLoading: false})
    };

    handleNewAPChange = ({target: {value}}, property) => {
        const {newAP} = this.state;
        newAP[property] = value;
        this.setState({newAP})
    };
    handleNewAPAddressChange = ({target: {value}}, property) => {
        let {newAP, newAP: {address}} = this.state;
        address = address ? address : {};
        address[property] = value;
        newAP.address = address;
        console.log("address", newAP);
        this.setState({newAP})
    };
    handleNewAPSelect = ({value}, property) => {
        const {newAP} = this.state;
        const {individual: {individual}} = this.props;
        console.log(individual.firstName);
        switch (property) {
            case 'phoneNumber':
                newAP[property] = value;
                break;
            case 'address':
                const address = _.find(individual.addresses, (testAddress) => (testAddress.line1 === value));
                newAP.address = address;
                break;
        }
        this.setState({newAP});
    };

    onRemoveAP = (value) => {
        this.setState({removing: true, removingAP: value})

    }

    confirmRemove = () => {
        const {handleRemoveAP} = this.props;
        handleRemoveAP(this.state.removingAP);
        this.cancelRemove();
    }
    cancelRemove = () => {
        this.setState({removing: false, removingAP: null});
    }

    removeConfirm = () => {
        const {personsList} = this.props;
        const person = personsList[this.state.removingAP];
        return (
            <ConfirmDelete
                type={'Authorised Person'}
                confirmAction={this.confirmRemove}
                cancelAction={this.cancelRemove}
                detail={`${person.firstName} ${person.middleName ? person.middleName : ''} ${person.lastName}`}
            />
        )
    }

    onAddressUpdate = (item, change, person, value) => {
        const {onAddressChange} = this.props;
        const address = person.address ? person.address : {};
        address[item] = change;
        person.address = {...address};
        onAddressChange(value, person);
    };

    onAddressChoice = (choice, value, person) => {
        const {onAddressChange} = this.props;
        console.log(choice);
        person.address = {...person.addresses[choice]};
        console.log(person);
        onAddressChange(value, person);
    };

    authorisedPerson = (person, value) => {
        const wellStyles = {maxWidth: 600, margin: '0 auto 10px'};
        const {errors} = this.props;
        const {addresses} = person;
        const addressChoice = addresses ? addresses.map(addressC => addressC.line1 + ', ' + addressC.line2) : null;
        const {address} = person;
        return (
            <Panel eventKey={value} key={person.identityNumber} bsStyle="primary">
                <Panel.Heading>
                    <Panel.Title toggle>
                        <span className="caret"/><Badge>OPEN</Badge>&nbsp;
                        {person.firstName} {person.middleName ? person.middleName : ''} {person.lastName}
                    </Panel.Title>
                </Panel.Heading>
                <Panel.Body collapsible>
                    <div className="col-md-6">
                        <div className="card-container-form">
                            <div className="section-title">
                                <span>ID Number:</span>
                            </div>
                            <div className="col-md-8">
                                <input className="form-control" disabled={true} defaultValue={person.identityNumber}/>
                            </div>
                        </div>
                        <br/>
                        <div className="card-container-form">
                            <div className="section-title">
                                <span>Email Address:</span>
                            </div>
                            <div className="col-md-8">
                                <input className="form-control" defaultValue={person.email}/>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6">
                        {
                            addressChoice &&
                            <div className="card-container-form">
                                <div className="section-title">
                                    <span>Choose address:</span>
                                </div>
                                <FormField className="form-group" id="regAddress">
                                    <select name="address" className={'form-control'}
                                            onChange={e => this.onAddressChoice(e.target.value, value, person)}>
                                        <option value=''>--SELECT--</option>
                                        {
                                            addressChoice.map((addressItem, i) => {
                                                return (<option key={i} value={i}>{addressItem}</option>)
                                            })
                                        }
                                    </select>
                                </FormField>
                            </div>
                        }
                        <div className="card-container-form">
                            <div className="section-title">
                                <span>Registered Address <span className='text-danger'>*</span></span>
                            </div>

                            <FormField className="form-group" id="regAddress" error={errors && errors.street}>
                                <label htmlFor="registeredAddressLin1">Address</label>
                                <input
                                    className="form-control"
                                    id={`registeredAddressLine1-${value}`}
                                    onChange={(event) => {
                                        this.onAddressUpdate('line1', event.target.value, person, value)
                                    }}
                                    type="text"
                                    defaultValue={address && address.line1}

                                />
                            </FormField>

                            <FormField className="form-group" id="line2" error={errors && errors.suburb}>
                                <label htmlFor="registeredAddressLine2">Suburb</label>
                                <input
                                    className="form-control"
                                    id={`registeredAddressLine2-${value}`}
                                    onChange={(event) => {
                                        this.onAddressUpdate('line2', event.target.value, person, value)
                                    }}
                                    type="text"
                                    defaultValue={address && address.line2}
                                />
                            </FormField>

                            <FormField className="form-group" id="regCity" error={errors && errors.city}>
                                <label htmlFor="registeredCity">City</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id={`registeredCity-${value}`}
                                    defaultValue={address && address.line3}
                                    onChange={(event) => {
                                        this.onAddressUpdate('line3', event.target.value, person, value)
                                    }}
                                />
                            </FormField>

                            <FormField className="form-group" id="regPostalCode" error={errors && errors.postalCode}>
                                <label htmlFor={`registeredZipOrPostalCode-${value}`}>Zip/Postal Code</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name={'postalCode'}
                                    id={`registeredZipOrPostalCode-${value}`}
                                    defaultValue={address && address.postalCode}
                                    onChange={(event) => {
                                        this.onAddressUpdate('postalCode', event.target.value, person, value)
                                    }}
                                />
                            </FormField>
                        </div>
                    </div>
                    <Col md={12}>
                        <div className="btn-block" style={wellStyles}>
                            <Button bsStyle="primary" bsSize="large" block
                                    onClick={this.onSave}>
                                Save
                            </Button>
                            <Button bsStyle="danger" bsSize="large" block
                                    onClick={() => this.onRemoveAP(value)}>
                                Remove
                            </Button>
                        </div>
                    </Col>
                </Panel.Body>
            </Panel>
        )
    }

    render() {
        const {personsList} = this.props;
        const {newAP, searchComplete} = this.state;
        return (
            <div>
                <PanelGroup
                    accordion
                    id="accordion-controlled-example"
                    activeKey={this.state.activeKey}
                    onSelect={this.handleSelect}
                >
                    {
                        personsList &&
                        personsList.map((person, i) =>
                            this.authorisedPerson(person, i)
                        )
                    }
                </PanelGroup>
                <Modal show={this.state.newAuthorised}
                       onHide={() => this.setState({newAuthorised: false, newAP: {new: true}})}
                       bsSize={'large'}>
                    <Modal.Body>
                        <NewAuthorizedPerson
                            {...this.props}
                            newAP={newAP}
                            onSearch={this.onIndividualSearch}
                            handleSelectChange={this.handleNewAPSelect}
                            onChange={this.handleNewAPChange}
                            isSearchComplete={searchComplete}
                            onSubmit={this.handleNewAuthorisedPerson}
                            onAddressChange={this.handleNewAPAddressChange}
                        />
                    </Modal.Body>
                    {
                        this.state.isLoading &&
                        <div className="inner-spinner-container">
                            <ReactLoading type="spokes" color="#444"/>
                        </div>
                    }
                </Modal>
                {
                    this.state.removing && this.removeConfirm()

                }
                <Button onClick={() => this.setState({newAuthorised: true})}>Add Authorised Person</Button>
            </div>

        )
    }
}

function mapStateToProps({individual}) {
    return {individual};
}

export default connect(mapStateToProps)(AuthorisedPersonsComponent);

